var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLonely(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#ffe059;}.cls-5{fill:#00305f;}.cls-6{fill:#4795ff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1025,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1068.5,1551.8c-339,0-613.7-274.8-613.7-613.7a613.5,613.5,0,0,1,44.4-229.8A610.7,610.7,0,0,0,411.3,1025c0,338.9,274.8,613.7,613.7,613.7,257.7,0,478.3-158.8,569.2-383.9C1486.8,1432.8,1291.5,1551.8,1068.5,1551.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,411.3A610.4,610.4,0,0,0,659.9,531.7a706.9,706.9,0,0,1,453.2-18.9,27.8,27.8,0,0,0-3.3,5.1c-18.2,33.9,18.9,89.1,82.7,123.3s130.4,34.6,148.6.8a38.6,38.6,0,0,0,3.7-10.5c165.2,128,271.9,328.1,272.9,553.1a613.3,613.3,0,0,0,21-159.6C1638.7,686.1,1363.9,411.3,1025,411.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1339.4,
    cy: 698.8,
    rx: 30.8,
    ry: 52.8,
    transform: "translate(396.9 1879.5) rotate(-79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1235.1,
    cy: 718.7,
    rx: 17.2,
    ry: 25,
    transform: "translate(-4.9 1429) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1224.1,1010.3c-41.3,0-78.5-28.2-104.7-79.5a30,30,0,1,1,53.4-27.3c15,29.3,34.2,46.8,51.3,46.8s36.3-17.5,51.3-46.8a30,30,0,1,1,53.4,27.3C1302.6,982.1,1265.4,1010.3,1224.1,1010.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M825.9,1010.3c-41.3,0-78.5-28.2-104.7-79.5a30,30,0,1,1,53.4-27.3c15,29.3,34.2,46.8,51.3,46.8s36.3-17.5,51.3-46.8a30,30,0,1,1,53.4,27.3C904.4,982.1,867.2,1010.3,825.9,1010.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1136.8,1221.4a30.1,30.1,0,0,1-19.7-7.3c-31.4-27.2-62.4-41-92.1-41s-60.7,13.8-92.1,41a30,30,0,1,1-39.3-45.4c42.7-36.9,86.9-55.6,131.4-55.6s88.7,18.7,131.4,55.6a30,30,0,0,1-19.6,52.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M677.6,1176.5h0a67.8,67.8,0,0,0,56.2-61.1l6.5-74.4a24,24,0,0,0-33.6-23.9l-68.2,30.6a67.8,67.8,0,0,0-39.1,73.2h0A67.9,67.9,0,0,0,677.6,1176.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLonely);
export default __webpack_public_path__ + "static/media/lonely.4fad404272e1ba36be055610108aea3c.svg";
export { ForwardRef as ReactComponent };